import { render } from "./index.vue?vue&type=template&id=9487bd9e"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.vue?vue&type=style&index=0&id=9487bd9e&lang=css"
script.render = render

export default script